<template lang="pug">
div(v-if="vtnRequest")
  el-card(shadow='hover').card-collapse
    app-header-dados-processo(
      :processo="processo",
      :isCCR="false",
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").card-container
    div
      el-steps.card-container(:active='active', finish-status='success', simple)
        el-step(title='Dados do VTN')
        el-step(title='Confirmar dados VTN')

      validation-observer(ref='validation' tag='div', v-if="active === 0")
        div(v-if="active === 0")
          app-radios-tramitacao(
            :radios="acaoEmissaoVtn",
            :isDecisao="true",
            @changeRadio="changeRadioDespacho",
            :radioInicial="action",
          )
          informar-dados-ma(
            v-if="vtnRequest && !isDespacho"
            :vtnRequest="vtnRequest",
          )
      div(v-if="active === 1 && !isDespacho")
        ConfirmarDados(
          :dadosVtn="calculado"
        )

      div(v-if="isDespacho")
        el-card(v-if="isArquivamentoIndeferimento && !isReurbIndividual")
            app-label(
              label="Inclua a Carta de Notificação ao Interessado"
              :required="isValidateCarta !== ''"
            )
            validation-provider(:rules="isValidateCarta", v-slot="{ errors }")
              app-anexo(
                :id="'upload-carta-notificacao'"
                @uploadFile="uploadCartaNotificacao",
                :files="cartas",
                @removeFile="removeCartaNotificacao",
                :showAnexar="true"
                :errors="errors"
                @downloadDocumentoCadastro="getDownload",
                :tiposArquivosPermitidos="tiposArquivosPermitidosMapas"
                v-model="cartas"
                :showUpload="cartas.length === 0"
              )
        validation-provider(rules="required", v-slot="{ errors }")
          app-label.input-text-editor(label="Despacho")
          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="despacho.textoDespacho",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
        app-anexo(
          :id="'upload-anexo-despacho'",
          @uploadFile="uploadFile",
          :files="despacho.documentos",
          @removeFile="removeFile"
          @downloadDocumentoCadastro="downloadDocumentoCadastro",
          :tipoExibir="'ANEXO_ANALISE'"
        )
      validation-observer(ref='validation2' tag='div', v-if="active === 1 || isDespacho")
        app-radios-tramitacao(
          :isDecisao="false",
          :radios="getAcoes",
          @changeRadio="changeRadio",
        )
      app-buttons-cadastro(
        :showButtonCancelar='true',
        :showButtonSalvar='true',
        :showButtonProximo='!isUltimoPasso'
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="isPrimeiroPasso",
        @proximo="proximo",
        @voltar="voltar",
        @cancelar='cancelar',
        @salvar="salvar",
        @finalizar='finalizar'
      )
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmarDados from './components/ConfirmarDadosMa.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

const { acaoEmissaoVtn, acoesRetornarRevisaoVTN } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default {
  components: {
    AppHeaderDadosProcesso,
    AppButtonsCadastro,
    ConfirmarDados,
    AppRadiosTramitacao,
    AppEditorTexto,
    AppLabel,
    AppAnexo
  },

  props: {
    idProcesso: {
      type: Number,
      required: true
    },
    protocolo: {
      type: String,
      required: true
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      active: 0,
      vtnRequest: null,
      acao: null,
      cartas: [],
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      dadosVtn: {},
      acoesRadio: [],
      radios: null,
      processo: null,
      calculado: null,
      dadosCadastro: '',
      despacho: {
        textoDespacho: '',
        documentos: []
      },
      action: 'CALCULO_VTN',
      acaoEmissaoVtn: acaoEmissaoVtn,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      }
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.active === 0
    },
    isUltimoPasso () {
      return this.active === 1 || this.action === 'DESPACHO'
    },
    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    isDespacho () {
      return this.action === 'DESPACHO'
    },
    getAcoes () {
      if (this.action === 'DESPACHO') {
        return this.radios.acoes.filter(item => acoesRetornarRevisaoVTN.includes(item.valor))
      } else {
        return this.radios.acoes.filter(item => !acoesRetornarRevisaoVTN.includes(item.valor))
      }
    },
    isValidateCarta () {
      return this.cartas?.length === 0 ? 'required' : ''
    },
    isArquivamentoIndeferimento () {
      return this.acao?.includes('ARQUIVAMENTO') && !this?.dadosCadastros?.despacho?.acao?.includes('DESARQUIVAMENTO')
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.processo.tipo.codigo)
    }
  },

  async created () {
    this.processo = await this.getProcesso(this.protocolo)
    this.dadosVtn = await this.getVtnByIdProcesso(this.idProcesso)
    this.radios = await this.tarefa({ processo: this.idProcesso })
    this.acoesRadio = this.radios.acoes

    this.vtnRequest = {
      areaRequerida: this.dadosVtn?.calculosVtn?.areaRequerida,
      municipio: this.dadosVtn.municipio,
      nivel: this.dadosVtn?.calculosVtn?.nivel,
      taxaDiversa: this.dadosVtn?.calculosVtn?.taxaDiversa
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo',
      getVtnByIdProcesso: 'vtn/getVtnProcessoId',
      finalizarVTNMA: 'vtn/finalizarVTNMA',
      salvarVTNMA: 'vtn/salvarVTNMA',
      tarefa: 'processo/tarefa'
    }),

    setCartaNotificacaoInteressado () {
      this.cartas.forEach(carta => {
        this.despacho.documentos.push(carta)
      })
    },

    async finalizar () {
      const valido = await this.$refs.validation2.validate()
      if (this.isArquivamentoIndeferimento) {
        this.setCartaNotificacaoInteressado()
        this.cartas = []
      }
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        return
      }
      this.confirmBox(
        this.$messages.FINALIZAR_ANALISE,
        this.$messages.TITULO_WARNING,
        async () => {
          const despacho = {
            isDespacho: this.action === 'DESPACHO',
            ...this.despacho
          }
          const mensagem = await this.finalizarVTNMA({idProcesso: this.dadosVtn.id, acao: this.acao, despacho})
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.$messages.PROCESSOS_ENCAMINHADOS.replace('$$', mensagem)
          )
          this.goToListagem()
        })
    },
    changeRadio (value) {
      this.acao = value.acao
    },
    onTextChange (text) {
      this.despacho.textoDespacho = text
    },
    changeRadioDespacho (value) {
      this.action = value.acao
    },
    cancelar () {
      this.$router.back()
    },
    goToListagem () {
      this.$router.push({
        name: 'CAIXA_ENTRADA'
      })
    },
    uploadFile (file) {
      this.despacho.documentos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.id === documento.id)
        )
        this.despacho.documentos.splice(index, 1)
      } else {
        const index = this.despacho.documentos.indexOf(
          this.despacho.documentos.find(a => a.key === documento.key)
        )
        this.despacho.documentos.splice(index, 1)
      }
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    uploadCartaNotificacao (file) {
      this.cartas.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 341,
          codigo: 'CARTA_NOTIFICACAO_INTERESSADO'
        }
      })
    },
    removeCartaNotificacao (documento) {
      const index = this.cartas.indexOf(
        this.cartas.find(m => m.key === documento.key)
      )
      this.cartas.splice(index, 1)
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    async salvar () {
      if (!this.vtnRequest.nivel) {
        this.calculado = {
          ...this.vtnRequest
        }
        await this.salvarVTNMA({
          id: this.dadosVtn.id,
          dados: this.calculado
        })
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.DADOS_SALVOS_SUCESSO)
        return
      }
      const valorReferencia = this.vtnRequest.municipio.valorNivelMunicipio[this.vtnRequest.nivel.toLowerCase()]
      const valorVtn = valorReferencia * this.vtnRequest.areaRequerida
      const valorReferenciaImovel = this.vtnRequest.taxaDiversa ? valorVtn * 1.1 : valorVtn

      this.calculado = {
        ...this.vtnRequest,
        valorVtn,
        valorReferencia,
        valorReferenciaImovel
      }

      await this.salvarVTNMA({
        id: this.dadosVtn.id,
        dados: this.calculado
      })
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, this.$messages.DADOS_SALVOS_SUCESSO)
    },
    async proximo () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        return
      }
      await this.salvar()
      this.active = this.active + 1
    },
    voltar () {
      this.active = this.active - 1
    }
  }
}
</script>

<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 20px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.input-text-editor {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/CadastrarVtnMA.vue